var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColon = function SvgColon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1.852 5.433"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#001627",
    strokeWidth: 0.26458,
    d: "M.926.132c.433 0 .794.369.794.836s-.361.836-.794.836S.132 1.435.132.968.493.132.926.132z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M.926.132c.433 0 .794.369.794.836s-.361.836-.794.836S.132 1.435.132.968.493.132.926.132z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M.926.132c.433 0 .794.369.794.836s-.361.836-.794.836S.132 1.435.132.968.493.132.926.132z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M.926.132c.433 0 .794.369.794.836s-.361.836-.794.836S.132 1.435.132.968.493.132.926.132z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M.926.132c.433 0 .794.369.794.836s-.361.836-.794.836S.132 1.435.132.968.493.132.926.132z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M.926.132c.433 0 .794.369.794.836s-.361.836-.794.836S.132 1.435.132.968.493.132.926.132z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#001627",
    strokeWidth: 0.26458,
    d: "M.926 3.63c.433 0 .794.368.794.835S1.359 5.3.926 5.3s-.794-.368-.794-.835.361-.836.794-.836z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M.926 3.63c.433 0 .794.368.794.835S1.359 5.3.926 5.3s-.794-.368-.794-.835.361-.836.794-.836z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M.926 3.63c.433 0 .794.368.794.835S1.359 5.3.926 5.3s-.794-.368-.794-.835.361-.836.794-.836z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M.926 3.63c.433 0 .794.368.794.835S1.359 5.3.926 5.3s-.794-.368-.794-.835.361-.836.794-.836z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M.926 3.63c.433 0 .794.368.794.835S1.359 5.3.926 5.3s-.794-.368-.794-.835.361-.836.794-.836z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.26458,
    d: "M.926 3.63c.433 0 .794.368.794.835S1.359 5.3.926 5.3s-.794-.368-.794-.835.361-.836.794-.836z"
  }))));
};
export default SvgColon;